import { render, staticRenderFns } from "./InvestimentoForm.vue?vue&type=template&id=3e4566e5&scoped=true&"
import script from "./InvestimentoForm.vue?vue&type=script&lang=js&"
export * from "./InvestimentoForm.vue?vue&type=script&lang=js&"
import style0 from "./InvestimentoForm.vue?vue&type=style&index=0&id=3e4566e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4566e5",
  null
  
)

export default component.exports